angular.module('filters')
    .filter('OSName', ($translate, Util) => (os) => {

        os = (os || '').toLowerCase();

        switch (os) {

        case 'osx':
            return $translate.instant('cw.general.os.osx');
        case 'ios':
            return $translate.instant('cw.general.os.ios');
        case 'windows':
            return $translate.instant('cw.general.os.windows');
        case 'android':
            return $translate.instant('cw.general.os.android');
        default:
            return Util.capitalizeFirstLetter(os);

        }

    });



// WEBPACK FOOTER //
// ./scripts/common/filters/osName.js